"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require("./../.");
class TDEnv extends _1.Env {
    allowedActions(s) {
        const x = this.stox(s);
        const y = this.stoy(s);
        const allowedActions = new Array();
        if (x > 0) {
            allowedActions.push(0);
        }
        if (y > 0) {
            allowedActions.push(1);
        }
        if (y < this.height - 1) {
            allowedActions.push(2);
        }
        if (x < this.width - 1) {
            allowedActions.push(3);
        }
        return allowedActions;
    }
    stox(s) { return Math.floor(s / this.height); }
    stoy(s) { return s % this.height; }
}
exports.TDEnv = TDEnv;
//# sourceMappingURL=td-env.js.map